 

function Section2() { 
  
  return (

    <div className='grid grid-cols-2 py-5 desktop:py-32'>

          <div className='desktop:h-10/12 w-2/5 desktop:w-3/5 bg-primary relative -bottom-52 shadow-[-8px_10px_4px_rgba(255, 255, 255)] '>
              
          </div> 
          <p className='leading-loose desktop:leading-loose text-white-color -ml-20 text-justify desktop:w-9/12 w-full text-lg desktop:text-3xl '>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
          </p>
    </div>
  )
}

export default Section2